import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Enum } from 'src/app/core/resources/enum.resource';

@Component({
  selector: 'atm-sort-item',
  templateUrl: './sort-item.component.html',
  styleUrls: ['./sort-item.component.scss'],
})
export class SortItemComponent implements OnInit {
  @Input() items: Enum[] | null = [];
  @Input() itemsSetted: string[] | undefined = [];
  @Output() sendItemsSorted = new EventEmitter<(string | undefined)[]>();
  itemsSelected: { item: Enum; selected: boolean }[] = [];
  itemsUnselected: { item: Enum; selected: boolean }[] = [];

  constructor() {}

  ngOnInit(): void {
    this.generateSelectUnselectArray();
  }

  drop(event: CdkDragDrop<{ item: Enum; selected: boolean }[]>) {
    moveItemInArray(
      this.itemsSelected!,
      event.previousIndex,
      event.currentIndex
    );
    this.sendResult();
  }

  checkboxChange(
    e: MatCheckboxChange,
    item: { item: Enum; selected: boolean }
  ) {
    if (e.checked) {
      this.itemsSelected.push(item);
      this.itemsUnselected = this.itemsUnselected.filter(
        (elem) => item.item.code !== elem.item.code
      );
    } else {
      this.itemsUnselected.push(item);
      this.itemsSelected = this.itemsSelected.filter(
        (elem) => item.item.code !== elem.item.code
      );
    }
    this.sendResult();
  }

  private generateSelectUnselectArray() {
    this.itemsSelected = this.items!.filter((item) =>
      this.itemsSetted?.includes(item.code!)
    ).map((item) => ({ item, selected: true }));
    this.itemsUnselected = this.items!.filter(
      (item) => !this.itemsSetted?.includes(item.code!)
    ).map((item) => ({ item, selected: false }));
  }

  private sendResult() {
    const result = this.itemsSelected.map((item) => item.item.code);
    this.sendItemsSorted.next(result);
  }
}
